import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const livescoreDefaultLayout: LayoutRuntime = {
  feature: "livescore",
  layout: "default",
  rootClass: "gwd-livescore-layout--default",
};
